<div class="flex flex-col items-start pb-2">
  <aura-avatar
    [srcImage]="$safeNavigationMigration(filePreview()?.url)"
    [label]="placeholder()"
    [size]="'3xl'"
  />
  @if (filePreview(); as file) {
    <div class="flex items-center gap-3 pt-2">
      <span class="max-w-[180px] truncate text-sm">
        {{ file.name }}
      </span>
      <button mat-icon-button type="button" aria-label="Remove file" (click)="onRemoveClick()">
        <mat-icon>close</mat-icon>
      </button>
    </div>
  }
</div>
